import type { QueryReplacer } from '.';
import { getDatabricksConditionFieldValue } from './ConditionFieldReplacer';
import { getDatabricksConditionLimitValue } from './ConditionLimitReplacer';
import { getDatabricksConditionOrderValue } from './ConditionOrderReplacer';

export const ConditionAllReplacer: QueryReplacer = {
    regex: /\{conditionAll\}/,
    replace: (statement, _metadata, _filterValues, regexMatches, settings) => {
        const field = getDatabricksConditionFieldValue(settings);
        const order = getDatabricksConditionOrderValue(settings);
        const limit = getDatabricksConditionLimitValue(settings);
        const value = field && limit && order ? `ORDER BY ${field} ${order} LIMIT ${limit}` : '';

        return regexMatches.reduce((pre, cur) => pre.replace(cur.exact, value), statement);
    },
};
